type Hashable = string | number | symbol | boolean;

const isUnionType = <T extends Hashable>(value: Hashable, allowedValues: T[]): value is T => (
    allowedValues.includes(value as T)
);

export default isUnionType;
